import { faqThemeBodySchema } from "@redotech/redo-model/faq/faq-body-schema";

export const updateTheme = {
  name: "updateTheme" as const,
  input: faqThemeBodySchema,
  output: faqThemeBodySchema,
};
